// extracted by mini-css-extract-plugin
module.exports = {"root":"_d4b1b5","readMore":"_2f7d84","expanded":"_9f3f92","content":"_6443ea","showMoreButton":"_bb1718"};